import { useEffect, useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useNavigate } from "react-router-dom";

const laundryIcon = L.divIcon({
  className: "",
  html: `<div style="background:#2563EB;width:30px;height:30px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,.3);display:flex;align-items:center;justify-content:center;">
    <div style="transform:rotate(45deg);color:white;font-size:14px;font-weight:700;">W</div></div>`,
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  popupAnchor: [0, -30],
});

const userIcon = L.divIcon({
  className: "",
  html: `<div style="background:#F97316;width:18px;height:18px;border-radius:50%;border:3px solid white;box-shadow:0 0 0 4px rgba(249,115,22,.3);"></div>`,
  iconSize: [18, 18],
  iconAnchor: [9, 9],
});

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length === 0) return;
    if (points.length === 1) {
      map.setView(points[0], 13);
    } else {
      map.fitBounds(points, { padding: [40, 40] });
    }
  }, [points, map]);
  return null;
}

export default function LaundryMap({ laundries, userCoords }) {
  const navigate = useNavigate();
  const located = useMemo(() => laundries.filter((l) => l.lat && l.lng), [laundries]);
  const points = useMemo(() => {
    const p = located.map((l) => [l.lat, l.lng]);
    if (userCoords) p.push([userCoords.lat, userCoords.lng]);
    return p;
  }, [located, userCoords]);

  const center = points[0] || [51.5074, -0.1278];

  return (
    <div className="h-[360px] w-full overflow-hidden rounded-xl border border-slate-200" data-testid="laundry-map">
      <MapContainer center={center} zoom={11} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FitBounds points={points} />
        {userCoords && (
          <Marker position={[userCoords.lat, userCoords.lng]} icon={userIcon}>
            <Popup>You are here</Popup>
          </Marker>
        )}
        {located.map((l) => (
          <Marker key={l.id} position={[l.lat, l.lng]} icon={laundryIcon}>
            <Popup>
              <div className="min-w-[150px]">
                <p className="font-semibold text-slate-900">{l.name}</p>
                <p className="text-xs text-slate-500">{l.city}{l.postcode ? `, ${l.postcode}` : ""}</p>
                {l.distance_km != null && <p className="text-xs text-slate-400">{l.distance_km} km away</p>}
                <button
                  onClick={() => navigate(`/laundry/${l.id}`)}
                  className="mt-2 w-full rounded-md bg-[#2563EB] px-3 py-1.5 text-xs font-semibold text-white"
                  data-testid={`map-book-${l.id}`}
                >
                  View & book
                </button>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
